import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import { DateFormat } from 'hooks';
import {CONSTANTS} from '../../constants';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const MultiAxisLineChart = (props) => {

    const labels = (props.graphData && props.graphData.label)?props.graphData.label:[];
    const prevLabels = (props.prevGraphData && props.prevGraphData.label)?props.prevGraphData.label:[];
    const options = {
        scales: {
            y: {
                ticks: {
                    callback: function(value, index, ticks) {
                        return CONSTANTS.CURRENCY+value;
                    }
                }
            }            
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        console.log('tooltipItem', tooltipItem.dataset.label);
                        
                        return `${tooltipItem.dataset.label} ${CONSTANTS.CURRENCY}${tooltipItem.raw}`
                    },
                    title: function(tooltipItem, data) {
                        const index = labels.findIndex((item)=>item === tooltipItem[0].label);
                        return ((index > -1))?`${DateFormat(tooltipItem[0].label,'dddd DD MMMM')} vs ${DateFormat(prevLabels[index],'dddd DD MMMM')}`:`${DateFormat(tooltipItem[0].label,'dddd DD MMMM')}`;
                    }
                }
            },
            legend: true,
            title: {
                display: false,
                text: 'Chart.js Line Chart',
            },
            
        },
    };

   
    const data = {
        labels:(props.data && props.data.date)?props.data.date:[],
        datasets: [
            {

                data: (props.data && props.data.credit)?props.data.credit:[],
                borderColor: '#00aee4',
                backgroundColor: '#00aee4',
                borderWidth:1,
                pointRadius: 2,
                label:'Credit Amount'
            },
            {

                data: (props.data && props.data.debit)?props.data.debit:[],
                borderColor: 'rgb(252, 92, 125)',
                backgroundColor: 'rgb(252, 92, 125)',
                borderWidth:1,
                pointRadius: 2,
                label:'Debit Amount'
            },
            

        ],
    };
    return (<Line options={options} data={data} />);
}

export default MultiAxisLineChart;